import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, from, of, switchMap } from 'rxjs';
import { GlobalesService } from '../services/globales.service';
import { MainService } from '../api/main.service';
import { MenuService } from '../services/menu.service';
import { Capacitor } from '@capacitor/core';

export const AuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router)
  const service = inject(MainService)
  const globales = inject(GlobalesService)
  const menuService = inject(MenuService)

  if (Capacitor.isNativePlatform()) {
    return from(router.navigateByUrl('/escanear-qr-subir-fotos'))
  }

  return from(service.GetCurrentUser()).pipe(
    switchMap(currentUser => {
      if (currentUser != null) {
        menuService.RecargarMenu()
        return of(true)
      }
      globales.redirectUrl = state.url
      return of(router.navigateByUrl('/login', {
        skipLocationChange: true
      }))
    }),
    catchError(_ => {
      globales.redirectUrl = state.url
      return of(router.navigateByUrl('/login', {
        skipLocationChange: true
      }))
    })
  ) as Observable<boolean | UrlTree>
}
